
import { Component, Vue, Prop } from 'vue-property-decorator'
import ImageSlider from '../ImageSlider.vue'
import { IPhoto } from '@/types/photos'
@Component({
  components: {
    ImageSlider
  }
})
export default class ProjectInfo extends Vue {
  @Prop() images!: IPhoto[]
  @Prop() title!: string
  @Prop() orgaColor!: string
}
